import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';

import { AppScrollerContainer, InjectedAppScrollerProps, withAppScroller } from 'src/_context/AppScroller';
import { Language } from 'src/utils/Languages';
import Footer from './Footer';
import MainPart from './MainPart';
import PanelIntroduction from './Panels/PanelIntroduction';
import PanelText from './Panels/PanelText';
import PanelTextImage from './Panels/PanelTextImage';
import PanelTextQuote from './Panels/PanelTextQuote';
import Section from './Section';

export type SecondaryPageProps =
    {
        loaded: boolean;
        pageDto: SecondaryPageDto;
    };

const styles = {
};

type Props =
    SecondaryPageProps &
    StyledComponentProps<keyof typeof styles> &
    InjectedAppScrollerProps;

type State = {

};
class SecondaryPage extends React.Component<Props, State> {
    public readonly state: State = {}

    render() {
        const {
            loaded,
            pageDto: { Sections, Title, UID },
        } = this.props;

        return (
            <AppScrollerContainer>
                <MainPart
                    loading={!loaded}
                    title={Title}
                    url={`/${Language}/${UID}`}
                    topLine={false}
                >
                    {Sections.map((s, c) => (
                        <Section {...{
                            title: s.Title,
                            noTitle: s.NoTitle,
                            id: s.UID,
                            hasBottomLine: c === Sections.length - 1 ? false : true,
                            key: s.UID
                        }}
                        >
                            {s.Panels.map((p, j) => {
                                switch (p.type) {
                                    case 'PanelIntroduction':
                                        const dto = p as PanelIntroductionDto;
                                        return (
                                            <PanelIntroduction key={j} dto={dto} />);
                                    case 'PanelTextQuote':
                                        const panelTextQuoteDto = p as PanelTextQuoteDto;
                                        return (
                                            <PanelTextQuote
                                                dto={panelTextQuoteDto}
                                                key={j}
                                                reverse={j % 2 !== 0}
                                            />
                                        );
                                    case 'PanelTextImage':
                                        const panelTextImage = p as PanelTextImageDto;
                                        return (
                                            <PanelTextImage
                                                dto={panelTextImage}
                                                key={j}
                                                reverse={j % 2 !== 0}
                                            />
                                        );
                                    case 'PanelText':
                                        const panelText = p as PanelTextDto;
                                        return (
                                            <PanelText key={j} dto={panelText} secondaryPage={true} />
                                        );
                                    default:
                                        return null;
                                }
                            })}
                        </Section>
                    ))}
                    <Footer loading={!loaded} />
                </MainPart>
            </AppScrollerContainer>);
    }
}

export default withStyles(styles)(withAppScroller(SecondaryPage));


// WEBPACK FOOTER //
// ./src/components/SecondaryPage.tsx